export default {
  admin: "admin",
  doctor: "doctor",
  nurse: "nurse",
  patient: "patient",
};
